<template>
    <view-with-bar>

        <template #bar>
            <view-bar>

                <h1>{{ $t('reporting.definitions') }}</h1>

                <view-bar-item route="/reporting/definitions">{{ $t('reporting.definitions') }}</view-bar-item>

                <view-bar-header class='view-bar-header' :actions="headerActions" @add="handleCreateNewComparison">
                    {{ $t('reporting.comparison') }}
                </view-bar-header>


                <view-bar-item v-for="comparison in comparisons"
                               :key="comparison.id"
                               :route="`/reporting/comparison/${comparison.id}`">{{ comparison.name }}
                </view-bar-item>
            </view-bar>
        </template>

    </view-with-bar>
</template>

<script>
import ViewWithBar from "@/components/layout/ViewWithBar";
import ViewBarItem from "@/components/navigation/ViewBarItem";
import ViewBar from "@/components/navigation/ViewBar";
import ViewBarHeader from "@/components/navigation/ViewBarHeader";

import { mapState } from "vuex";

export default {
    name: "VarCalculationView",
    components: {ViewBarHeader, ViewBar, ViewBarItem, ViewWithBar},
    data() {
        return {
            headerActions: [{name: 'add', icon: 'plus-circle'}],
        }
    },
    computed: {
        ...mapState('comparison', {
            comparisons: 'comparisons'
        }),
    },
    methods: {
        handleCreateNewComparison() {
            this.$router.push('/reporting/comparison/new')
        },

    },
    async mounted() {
        await this.$store.dispatch("operationQueries/refreshOperationQueries");
        this.$store.commit('comparison/loadFromLocalStorage')
    }

}
</script>

<style scoped lang="scss">
.view-bar-header {
    background-color: rgba(255, 255, 255, 0.06);
    padding: 0 10px;
    user-select: none;
}
</style>